import React from "react";
import { useDispatch } from "react-redux";
import { closeModalWithResult } from "../../../store/modalSlice";
import { updateProject } from "../../../store/projectSlice";
import ImageUploadFlow from "../ImageUploadFlow";
import type { AppDispatch } from "../../../store";

// Payload this modal reports back to its caller (create flow reads it via the __returnTo handoff)
export interface ProjectImageUploadResult {
  success: boolean;
  action: "updateImage";
  imageUrl?: string;
  error?: unknown;
}

interface ProjectImageUploadModalProps {
  asset: any;
  onClose?: (result?: ProjectImageUploadResult) => void;
}

const ProjectImageUploadModal: React.FC<ProjectImageUploadModalProps> = ({ asset, onClose }) => {
  const dispatch = useDispatch<AppDispatch>();

  const handleClose = (result?: any) => {
    dispatch(closeModalWithResult(result ?? null));
    onClose?.(result);
  };

  const handleUploadSuccess = async ({ imageUrl }: { imageUrl: string }) => {
    // Editing an existing project — persist to DynamoDB; unwrap so a rejected thunk isn't swallowed
    if (asset?.id) {
      try {
        await dispatch(updateProject({ id: asset.id, imageUrl })).unwrap();
      } catch (err) {
        // Report failure to the caller instead of falsely closing with success
        handleClose({ success: false, action: "updateImage", error: err });
        return;
      }
    }
    // Close with the imageUrl so the parent can use it (create flow)
    handleClose({ success: true, action: "updateImage", imageUrl });
  };

  return (
    <ImageUploadFlow
      asset={asset}
      onClose={handleClose}
      uploadTarget="generic"
      onUploadSuccess={handleUploadSuccess}
    />
  );
};

export default ProjectImageUploadModal;
